import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'

Vue.use(Vuex)

const store = () => {
  return new Vuex.Store({
    state: {
      baseUrl: process.env.ROOT_URL,
      apiRoot: process.env.API_ENDPOINT,
      isLoading: true,
      useLoadingWindow: true,
      showEyecatch: false,
      isSmartPhone: true,
      pageTitle: null,
      resizeCount: 0,
      getSpDir: '',
      modal: {
        show: false,
      },
      gallery: {
        items: {
          1: { heading: 'Entrance(エントランス)',
            text: '入ってすぐに見えるALHのランプとHARMONIZERランプ、そして床のロゴカーペットがバランスよく構図になるフォトスポット。ウェイティングスペースのベンチは、ロゴをかたどったオーダーメイド家具。フタを開けると収納になる。'
          },
          2: { heading: 'Café Counter Area(カフェカウンターエリア)',
            text: 'どこから見ても台形に作られた特注のカウンター。側面はピアノの鍵盤をイメージして、一つ一つブロックが積み上げられた造りになっている。'
          },
          3: { heading: 'Meeting Booth Area(ミーティングブースエリア)',
            text: 'ファミレスのボックスシート席を模したミーティングスペース。椅子の下も収納になり、災害用物資などの収納にも役立つ。さらに窓際も座れるようになっているので陽射しを浴びることもできる。'
          },
          4: { heading: 'Barefoot Area(ベアフットエリア)',
            text: '床材は撥水加工を施した特注のカラフルな畳になっている。体にフィットするクッションが置いてあり、裸足でリラックスして過ごせる。'
          },
          5: { heading: 'Step Area(ステップエリア)',
            text: '階段状のスペースになっていて、集合写真を撮る時の絶対的インスタ映えスポット。実は階段の側面が本棚になっている。'
          },
          6: { heading: 'Sofa Area(ソファエリア)',
            text: '座り心地を追求したソファーを配したカジュアルなミーティングスペース。ランチスポットとしても人気のエリア。'
          },
          7: { heading: 'Anything Wall Area(エニシングウォールエリア)',
            text: '壁一面がホワイトボードになっていて、ライトなスタンディングミーティングやブレインストーミングが盛んにおこなわれる。時には自由なキャンバスに。'
          },
          8: { heading: 'Projector & Screen(プロジェクター&スクリーン)',
            text: 'フリースペースエリアには高精度プロジェクターと巨大スクリーンを完備。さらに高音質な音響設備とともに大画面での映画鑑賞も可能。プレゼンテーションが楽しくなるエリア。'
          },
          9: { heading: 'Aria(アリア)[詠嘆曲]',
            text: 'ワインが運ばれてきそうな大人の雰囲気を醸し出す、最もラグジュアリーな空間。ビビッドなレッドチェアーが強烈なインパクトに。'
          },
          10: { heading: 'Ballade(バラード)[譚詩曲]',
            text: 'ホテルのロビーを彷彿とさせるカーペットを採用。デザイン性に優れた照明がアクセント。柱の裏にあるため、隠れ家的存在でもある。'
          },
          11: { heading: 'Concerto(コンチェルト)[協奏曲]',
            text: '太陽をイメージさせるオブジェとカーペットに、広さと採光性を備えた会議室。テレビモニターも設置し、会議資料の投影も可能。'
          },
          12: { heading: 'Etude(エチュード)[練習曲]',
            text: 'シンプルだがデザイン性があるファブリックを配置。柔らかい黄色が会議の雰囲気を演出する。取材などにも頻繁に使われる。壁にあるコート掛けのオブジェがアクセント。'
          },
          13: { heading: 'Fantasia(ファンタジア)[幻想曲]',
            text: 'ジャングルに囲まれた海外リゾートホテルを切り取ったような空間に植物素材で編み込まれた椅子がアジアンな雰囲気をさらに演出。'
          },
          14: { heading: 'Hymn(ヒム)[聖歌]',
            text: 'アメリカ西海岸のサーフスタイルを象徴するカフェのような雰囲気。最大8名が着席可能で爽やかミーティングを演出。'
          },
          15: { heading: 'Kanon(カノン)[追走曲]',
            text: '爽やかなブルーを基調とした空間に、豪華なシャンデリアが象徴的な、女性一番人気の佇まい。体にフィットするツイード素材のチェアの座り心地が抜群。'
          },
          16: { heading: 'Menuet(メヌエット)[小歩舞曲]',
            text: '会議室の中で唯一ハイチェア、ハイテーブルを配置。スタンディングミーティングにも適しており、スピーディーなディスカッション空間でビジネスを後押し。'
          },
          17: { heading: 'Nocturne(ノクターン)[夜想曲]',
            text: '着物に帯を締めた和風美人を思わせる壁紙に、和紙をふんだんに使用した照明と掘り炬燵を配したオフィス異空間。'
          },
          18: { heading: 'Prelude(プレリュード)[前奏曲]',
            text: '幾何学模様の壁紙がサッカーボールを彷彿とさせ、ビビッドなピンクの壁紙とストライプの床材がスポーティーな力強さを強調。'
          },
          19: { heading: 'Rondo(ロンド)[輪舞曲]',
            text: '最も女性らしさが漂う空間。膝下が綺麗にカーブしている女性らしいフォルムの椅子に、パステルピンクの壁紙と角部屋の採光性が可愛らしさを演出。'
          },
          20: { heading: 'Sonata(ソナタ)[奏鳴曲]',
            text: 'ベージュを基調とした落ち着いた空間。ローテーブルを挟んで談笑する姿がリビングを思わせる。'
          },
          21: { heading: 'Traumerei(トロイメライ)[夢想曲]',
            text: '清潔感を全面に出した、幻想的な空間。全体的に造りが細めのファブリックが華奢で、上品さをさらに演出。'
          },
          22: { heading: 'Waltz(ワルツ)[円舞曲]',
            text: '重厚感のある応接室のような雰囲気。壁の色が光によって絶妙に変化する為、堅いイメージだけではなく、柔らかさやスタイリッシュさも演出。'
          },
          23: { heading: 'Seminar Room(セミナールーム) (Opera オペラ,Scala スカラ,Colon コロン)',
            text: '世界三大劇場の名前を冠にした最大90名着席可能なセミナールーム。廊下には豪華なレッドカーペットとスポットライトを配し、厳かな雰囲気を演出。パーティションを使えば3つのセミナールームに変身。'
          },
          24: { heading: 'Studio(スタジオ)',
            text: '社内外のメディアに発信するためのTV番組を制作したり、社員の写真や動画の撮影・制作に使用。プロ仕様のカメラ機材や照明機材を充実させ、社員カメラマンを配置する、メディア戦略の推進部。'
          },
        },
        length: 24
      },
      navi: {
        all: [
          { url: 'https://my.matterport.com/show/?m=TsQ6iijtmLN',
            text: 'VR Office tour',
            ja: '',
            hash: false,
            tag: null,
          },
          { url: '#philosophy',
            text: 'Philosophy',
            ja: '',
            hash: true,
            tag: null,
          },
          { url: '#gallery',
            text: 'Gallery',
            ja: '',
            hash: true,
            tag: null,
          },
          { url: '#concept',
            text: 'Concept',
            ja: '',
            hash: true,
            tag: null,
          },
          { url: '#scene',
            text: 'Scene',
            ja: '',
            hash: true,
            tag: null,
          },
          { url: 'https://recruit.alhinc.jp/',
            text: 'Recruit',
            ja: '',
            hash: false,
            tag: null,
          },
          { url: 'https://www.alhinc.jp/contact',
            text: 'Contact',
            ja: '',
            hash: false,
            tag: null,
          },
        ],
        list: [],
        currentPos: [],
        width: {},
      },
      params: [],
      answers: [],
    },
    actions: {
      isSmartPhone ({commit}) {
        let windowSize = () => {
          if (window.innerWidth < 769) {
            commit('IS_SMARTPHONE', true)
          } else {
            commit('IS_SMARTPHONE', false)
          }
        }
        windowSize()
        window.addEventListener('resize', windowSize)
      },
      getSpDir ({commit, state}) {
        let dir = (state.isSmartPhone) ? '/sp' : ''
        commit('GET_SP_DIR', dir)
      },
      getPageTitle ({commit, state}) {
        let getCurrent = () => {
          var path = location.href
          var arr = path.split('/')
          let current = arr.pop === ('') ? '/' : arr[arr.length - 1]
          let currentPos
          if (state.navi.list.indexOf(`/${current}`) !== -1) {
            currentPos = state.navi.list.indexOf(`/${current}`)
          } else {
            current = arr.indexOf('/')
          }

          commit('PAGE_TITLE', current)
          commit('NAVI_CURRENT_POS', currentPos)
        }
        getCurrent()
      }
    },
    mutations,
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js